import { render, staticRenderFns } from "./ProcessorManager.vue?vue&type=template&id=8b1bfe46&"
import script from "./ProcessorManager.vue?vue&type=script&lang=js&"
export * from "./ProcessorManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProcessorManager.vue"
export default component.exports